import React from 'react';
import { PropTypes } from 'prop-types';
import { useTranslation } from 'react-i18next';
import * as S from './styles';
import Icon from '~/components/Icon';
import CustomOption from '~/components/Filter/Select/components/CustomOption';

export default function Filter({
  selector,
  label,
  value,
  onChange,
  error,
  icon,
  noBorder,
  minWidth,
  ...rest
}) {
  const { t } = useTranslation();
  return (
    <S.Container noBorder={noBorder}>
      <S.Label htmlFor={selector}>{label}</S.Label>
      <S.InputWrapper errorColor={error.length > 0}>
        {icon && <Icon size={30} name={icon} color="gray" />}
        <S.Filter
          classNamePrefix="select"
          id={selector}
          value={value}
          onChange={e => onChange(e === null ? null : [e])}
          components={{ Option: props => CustomOption({ ...props }) }}
          noOptionsMessage={() => t('noOptions')}
          minWidth={minWidth}
          {...rest}
          isDisabled={rest.isLoading}
        />
      </S.InputWrapper>
    </S.Container>
  );
}

Filter.propTypes = {
  selector: PropTypes.string.isRequired,
  label: PropTypes.string,
  value: PropTypes.array,
  onChange: PropTypes.func,
  error: PropTypes.string,
  icon: PropTypes.string,
  noBorder: PropTypes.bool,
  minWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

Filter.defaultProps = {
  label: '',
  value: {},
  onChange: () => {},
  error: '',
  icon: '',
  noBorder: false,
  minWidth: 'auto',
};
